module.exports = __webpack_public_path__ + "static/media/logo-servicenow-landscape.af2d3c4e.svg";